import Vue from 'vue'
import VueRouter from 'vue-router'
Vue.use(VueRouter)

// 引入商品列表主页
const Index = () => import(/* webpackChunkName:"goods"*/ '../components/index.vue')
const specialImg_detail = () => import(/* webpackChunkName:"goods"*/ '../components/specialImg_detail.vue')
const special_detail2 = () => import(/* webpackChunkName:"goods"*/ '../components/special_detail2.vue')
const specialVideo_detail = () => import(/* webpackChunkName:"goods"*/ '../components/specialVideo_detail.vue')
const specialImg_list = () => import(/* webpackChunkName:"goods"*/ '../components/specialImg_list.vue')
const specialPage = () => import(/* webpackChunkName:"goods"*/ '../components/specialPage.vue')
const hfwl = () => import(/* webpackChunkName:"goods"*/ '../components/hfwl.vue')
const sutpk = () => import(/* webpackChunkName:"goods"*/ '../components/suzhou.vue')
const hlwuhu = () => import(/* webpackChunkName:"goods"*/ '../components/wuhu.vue')
const imgList = () => import(/* webpackChunkName:"goods"*/ '../components/img_list.vue')
const musicList = () => import(/* webpackChunkName:"goods"*/ '../components/music_list.vue')
const videoList = () => import(/* webpackChunkName:"goods"*/ '../components/video_list.vue')
const videoList_hfwl = () => import(/* webpackChunkName:"goods"*/ '../components/video_list_hfwl.vue')
const imgDetail = () => import(/* webpackChunkName:"goods"*/ '../components/img_detail.vue')
const audioDetail = () => import(/* webpackChunkName:"goods"*/ '../components/audio_detail.vue')
const videoDetail = () => import(/* webpackChunkName:"goods"*/ '../components/video_detail.vue')
const newsImg = () => import(/* webpackChunkName:"goods"*/ '../components/news_list.vue')
const newsDetail = () => import(/* webpackChunkName:"goods"*/ '../components/news_detail.vue')
const searchList = () => import(/* webpackChunkName:"goods"*/ '../components/search_list.vue')
const specialList = () => import(/* webpackChunkName:"goods"*/ '../components/special_list.vue')
const specialList_hfwl = () => import(/* webpackChunkName:"goods"*/ '../components/special_list_hfwl.vue')
const specialDetail = () => import(/* webpackChunkName:"goods"*/ '../components/special_detail.vue')
const register = () => import(/* webpackChunkName:"goods"*/ '../components/register.vue')
const forget = () => import(/* webpackChunkName:"goods"*/ '../components/forget.vue')
const userIndex = () => import(/* webpackChunkName:"goods"*/ '../components/user_index.vue')
const userDepot = () => import(/* webpackChunkName:"goods"*/ '../components/user_depot.vue')
const userOrder = () => import(/* webpackChunkName:"goods"*/ '../components/user_order.vue')
const userCollect = () => import(/* webpackChunkName:"goods"*/ '../components/user_collect.vue')
const userCbt = () => import(/* webpackChunkName:"goods"*/ '../components/user_cbt.vue')
const userCbtlook = () => import(/* webpackChunkName:"goods"*/ '../components/user_cbtlook.vue')
const userInfo = () => import(/* webpackChunkName:"goods"*/ '../components/user_info.vue')
const userPwd = () => import(/* webpackChunkName:"goods"*/ '../components/user_pwd.vue')
const userAuth = () => import(/* webpackChunkName:"goods"*/ '../components/user_auth.vue')
const payMant = () => import(/* webpackChunkName:"goods"*/ '../components/paymant.vue')
const addPhone = () => import(/* webpackChunkName:"goods"*/ '../components/addphone.vue')
const about = () => import(/* webpackChunkName:"goods"*/ '../components/about.vue')
const journal = () => import(/* webpackChunkName:"goods"*/ '../components/journal.vue')
const textbrigade = () => import(/* webpackChunkName:"goods"*/ '../components/textbrigade.vue')
const xbcm = () => import(/* webpackChunkName:"goods"*/ '../components/xbcm.vue')
const navxbcmimg_list = () => import(/* webpackChunkName:"goods"*/ '../components/navxbcmimgList.vue')
const laswxcb = () => import(/* webpackChunkName:"goods"*/ '../components/laswxcb.vue')
const img_laxcbjjp = () => import(/* webpackChunkName:"goods"*/ '../components/img_laxcbjjp.vue')

const szimgList = () => import(/* webpackChunkName:"goods"*/ '../components/img_sztpklist.vue')
const electronicBrochure = () => import(/* webpackChunkName:"goods"*/ '../components/electronicBrochure.vue')



const routes = [
  { path: '/', redirect: '/index' },
  // /img_hfwllist
  { path: '/img_hfwllist', component: imgList, name: 'hfwl' },
  { path: '/special_hfwldetail', component: specialDetail, name: 'hfwl' },
  { path: '/img_sztpklist', component: szimgList, name: 'sutpk' },
  { path: '/img_hlwhlist', component: szimgList, name: 'hlwuhu' },
  { path: '/index', component: Index },
  { path: '/hwswlj', component: specialPage },
  { path: '/hfwl', component: hfwl, name: 'hfwl' },
  { path: '/sutpk', component: sutpk, name: 'sutpk' },
  { path: '/hlwuhu', component: hlwuhu, name: 'hlwuhu' },
  { path: '/img_list', component: imgList },
  { path: '/music_list', component: musicList },
  { path: '/video_list', component: videoList },
  { path: '/video_list_hfwl', component: videoList_hfwl },
  { path: '/img_detail', component: imgDetail },
  { path: '/audio_detail', component: audioDetail },
  { path: '/video_detail', component: videoDetail },
  { path: '/news_list', component: newsImg },
  { path: '/news_detail', component: newsDetail },
  { path: '/search_list', component: searchList },
  { path: '/special_list', component: specialList },
  { path: '/special_list_hfwl', component: specialList_hfwl },
  { path: '/special_detail', component: specialDetail },
  { path: '/register', component: register },
  { path: '/userIndex', component: userIndex },
  { path: '/userDepot', component: userDepot },
  { path: '/userOrder', component: userOrder },
  { path: '/userCollect', component: userCollect },
  { path: '/userCbt', component: userCbt },
  { path: '/userCbtlook', component: userCbtlook },
  { path: '/userInfo', component: userInfo },
  { path: '/userPwd', component: userPwd },
  { path: '/userAuth', component: userAuth },
  { path: '/forget', component: forget },
  { path: '/addPhone', component: addPhone },
  { path: '/about', component: about, name: 'about' },
  { path: '/payMant', component: payMant, name: 'payMant' },
  { path: '/journal', component: journal, name: 'journal' },
  { path: '/ahwl', component: textbrigade, name: 'textbrigade' },
  { path: '/electronicBrochure', component: electronicBrochure, name: 'electronicBrochure' },
  { path: '/specialimg_detail', component: specialImg_detail, name: 'specialImg_detail' },
  { path: '/specialvideo_detail', component: specialVideo_detail, name: 'specialVideo_detail' },
  { path: '/specialimg_list', component: specialImg_list, name: 'specialImg_list' },
  { path: '/special_detail2', component: special_detail2, name: 'special_detail2' },
  { path: '/xbcm', component: xbcm, name: 'xbcm' },
  { path: '/navxbcmimg_list', component: navxbcmimg_list, name: 'navxbcmimg_list' },
  { path: '/laswxcb', component: laswxcb, name: 'laswxcb' },
  { path: '/img_laxcbjjp', component: img_laxcbjjp, name: 'laswxcb' }
]

const router = new VueRouter({
  mode: 'history',  //去掉url中的#
  routes
})

export default router
